<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { brand, brandConfig, features } from '@/config/brands'

const ADSENSE_CLIENT_ID = brandConfig.texts?.adsenseClientId || ''
const ADSENSE_SLOT_ID = brandConfig.texts?.adsenseSlotId || ''
const AD_HOST_KEYWORD = brandConfig.texts?.adSenseHostKeyword || ''
const tag = `[AdSense-${brand}]`

const enableAdHost = computed(() => !AD_HOST_KEYWORD || location.hostname.includes(AD_HOST_KEYWORD))

const isReady = computed(() => {
  if (!features?.enableAdSense) {
    console.warn(tag, '功能未开启，跳过广告渲染')
    return false
  }
  if (!enableAdHost.value) {
    console.warn(tag, `域名不包含 ${AD_HOST_KEYWORD}，跳过广告渲染`, { hostname: location.hostname })
    return false
  }
  const ready = !!(ADSENSE_CLIENT_ID && ADSENSE_SLOT_ID)
  if (!ready)
    console.warn(tag, '配置缺失，跳过广告渲染', { ADSENSE_CLIENT_ID, ADSENSE_SLOT_ID })
  return ready
})

let scriptLoaded = false

function loadAdSenseScript(): Promise<void> {
  if (scriptLoaded) {
    // eslint-disable-next-line no-console
    console.log(tag, '脚本已加载，跳过')
    return Promise.resolve()
  }
  return new Promise((resolve) => {
    const existing = document.querySelector('script[src*="pagead2.googlesyndication.com"]')
    if (existing) {
      // eslint-disable-next-line no-console
      console.log(tag, '检测到已有脚本标签')
      scriptLoaded = true
      resolve()
      return
    }
    // eslint-disable-next-line no-console
    console.log(tag, '开始加载 adsbygoogle.js')
    const script = document.createElement('script')
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
    script.async = true
    script.crossOrigin = 'anonymous'
    script.onload = () => {
      // eslint-disable-next-line no-console
      console.log(tag, '脚本加载成功')
      scriptLoaded = true
      resolve()
    }
    script.onerror = (e) => {
      console.error(tag, '脚本加载失败', e)
      resolve()
    }
    document.head.appendChild(script)
  })
}

onMounted(async () => {
  if (!isReady.value)
    return
  // eslint-disable-next-line no-console
  console.log(tag, '广告组件已挂载', { ADSENSE_CLIENT_ID, ADSENSE_SLOT_ID })
  await loadAdSenseScript()
  try {
    ;(window as any).adsbygoogle = (window as any).adsbygoogle || []
    ;(window as any).adsbygoogle.push({})
    // eslint-disable-next-line no-console
    console.log(tag, 'adsbygoogle.push 执行成功')
  }
  catch (err) {
    console.error(tag, 'adsbygoogle.push 执行失败', err)
  }
})
</script>

<template>
  <div v-if="isReady" class="chapter-ad-sense">
    <div class="ad-placeholder">
      <span class="ad-label">Ad</span>
      <ins
        class="adsbygoogle"
        style="display:block; text-align:center"
        data-ad-layout="in-article"
        data-ad-format="fluid"
        :data-ad-client="ADSENSE_CLIENT_ID"
        :data-ad-slot="ADSENSE_SLOT_ID"
      />
    </div>
  </div>
</template>

<style scoped>
.chapter-ad-sense {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}

.ad-placeholder {
  width: 100%;
  min-height: 100px;
  background: #F5F5F5;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ad-label {
  position: absolute;
  top: 4px;
  right: 6px;
  font-size: 10px;
  color: #999;
  line-height: 1;
  user-select: none;
  pointer-events: none;
}
</style>
